(function(document, window, $) {
  'use strict';

  var Site = window.Site;

  $(document).ready(function($) {
    Site.run();

    var filter = $('#filter');

    if (!filter.length) return;

    var $panel = $('#filter-result');
    var $panelSelected = $('#filter-result .panel-selected');
    var api = $panel.data('panel-api');
    var filtering = true;
    var filter_in_progress=false;

    var pageChange = false;

      $panel.sortableNav();

      window.filterUnbindEvents = function(){
          $('#filter input, #filter select').unbind('change');
      };

      window.filterBindEvents = function(){
          $('#filter input, #filter select').change(function () {
              makeFilterRequest();

          });
      }
      window.initFilterOnChange = function() {
          filterUnbindEvents();
          filterBindEvents();
      }

      filterBindEvents();

      var mode = 'list';
      var md=$('#mode');
      if (md.length) mode = md.val();

      $('#filter').submit(function(event){
          if (filtering) {
              event.preventDefault();
              makeFilterRequest();
          }
      });

      $('body').on('activity:added', function(event){
          if (mode == 'list') makeFilterRequest();
      });

      $('#filter').on('filter:refresh', function( event ){
            makeFilterRequest();
      });

      window.filterRefresh = function(){
          makeFilterRequest();
      }


      $('#filter').on('filter:nofiltering', function(){
            filtering = false;
      });

      $('#filter').on('filter:filtering', function(){
          filtering = true;
      });

      $('#filter').on('filter:pagechange', function(){
          pageChange = true;
      });




      function makeFilterRequest(){

          if (! filtering) return;
          api.load(function(done) {

              //reset the page to 1 if there is a filter change
              if (! pageChange)  {
                  //location.replace("#page=" + 1);
                  $('input[name=page]').val(1);
              }
              pageChange = false;

              var $panel = $(this);
              $panel.find('.panel-body .content').html('');

              var url = filter.attr('data-href');
             // console.log('makeFilterRequest');
              if (filter_in_progress && $xhr != undefined) $xhr.abort();

              filter_in_progress=true;

              var $xhr = $.post(url, filter.serialize())
                  .done(function(data){
                      if (mode == 'list') {
                          $panel.find('.panel-body').html(data);
                          //markSortable();
                          selectableInit();
                          $panel.sortableNav('reset');
                          $('#filter-result').trigger('filter:done');
                      }else{
                          window[mode+'DataHandler'](data);
                      }
                  })
                  .fail(function(){
                      $panel.find('.panel-body .content').html();
                  })
                  .always(function(){
                      done();
                      filter_in_progress = false;
                  })
              ;

             // $panel.find('.panel-body').html('');
          });
      }

      //trigger first load
      if (mode=='list'){
          //var page = /\bpage=(\d+)\b/.test(location.hash) ? parseInt(RegExp.$1) : 1;
          //if (page){
          //    pageChange = true;
          //    $('input[name=page]').val(page);
          //}
          pageChange = true;
          makeFilterRequest();
      }


      //Pagination
      $(document).on('click','#filter-result .pagination a', function(e){
          e.preventDefault();
          var href= $(this).attr('href');
          //for this next line will do the trick but is not suggested to be used anywhere else
          var page=href.split('page=')[1];
          //location.hash = "#page=" + page;
         // location.replace("#page=" + page);
          pageChange = true;
          $('input[name=page]').val(page).trigger("change");

      });

      /*SELECTABLE START */

      //$(document).on('change','.selectable-item', function(e){
      //    var $main = $(this).closest('tr');
      //
      //    if ($(this).prop('checked')) addToSelected($main);
      //    else removeSelected($main);
      //
      //    e.preventDefault();
      //
      //});
      //
      //$(document).on('click','.btn-show-selected', function(e){
      //    $panel.find('.panel-body').addClass('hidden');
      //    $panelSelected.removeClass('hidden');
      //});
      //
      //function addToSelected($element){
      //    var $new = $element.clone();
      //    $new.addClass('isClone');
      //    $new.attr('id', 'clone_'+$new.attr('id'));
      //    if ($panelSelected.html()==''){
      //       var table = $panel.find('.panel-body table').clone();
      //          table.find('tbody').html('');
      //         $panelSelected.append(table);
      //    }
      //    $panelSelected.find('table tbody').append($new);
      //}
      //
      //function removeSelected($main)
      //{
      //    if ($main.hasClass('isClone')){
      //        $main.remove();
      //    }
      //}

    /*SELECTABLE END*/


      //$(document).on('click','#filter-result .sortablefield', function(e){
      //    e.preventDefault();
      //
      //    var sortActive = $('#filter input[name=order]').val();
      //    var sortDirection = $('#filter input[name=direction]').val();
      //
      //    var mysort = $(this).attr('data-field');
      //    var newdirection = 'asc';
      //    if (sortActive == mysort) newdirection = (sortDirection=='asc') ? 'desc' : 'asc';
      //
      //    $('#filter input[name=order]').val(mysort);
      //    $('#filter input[name=direction]').val(newdirection).trigger("change");
      //
      //
      //});




      function selectableInit(){
          $( document ).trigger( "enhance.tablesaw" );

          $.components._components.selectable.init();

          var $selectable = $('#filter-result [data-selectable]');

          $('#filter-result').trigger('selected:off');
          $('#filter-result').trigger('selected:changed');

          $selectable.on('asSelectable::change', function(e, api, checked) {

              $('#filter-result').trigger('selected:changed');


              if (checked) {
                  $('#filter-result').trigger('selected:on');
              } else {
                  $('#filter-result').trigger('selected:off');
              }

          });
      }

      //paging

      var paging = $('#filter input[name=limit]').val();
      $('#filter-result .paging [data-paging='+paging+']').addClass('active');

      $('#filter-result .paging a').on('click', function(){
          $('#filter-result .paging a.active').removeClass('active');
          $(this).addClass('active');
          $('input[name=limit]').val($(this).attr('data-paging')).trigger("change");
      })


  });


})(document, window, jQuery);
